import React, {Component} from 'react';
import objeler from '../objeler';
import 'react-dropdown/style.css'
import './modal.css'
import {Col, Container, Row} from 'react-bootstrap';

const dataProviderItems = require('../../items/dataProviders.json');

class PageProperties extends Component {
    options = [
        '6', '7', '8', '9'
    ];
    defaultOption = this.options[0];

    constructor(props) {
        super(props);
        this.refContinuous = React.createRef();
        this.refContinuousHeader = React.createRef();
        this.refContinuousTemplate = React.createRef();
        this.refShowEmptyPage = React.createRef();
        this.state = {
            activeFontFamily: "Open Sans",
            activeBold: "false",
            visibleTemplate: objeler.ModalPageParameters.Continuous
        };
        objeler['ModalPageValues'] = {...objeler.ModalPageParameters};
    };

    render() {
        const pStyle = {
            height: "16px",
            color: "#000000",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const textStyle = {
            display: "block",
            width: "100px",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const divStyle = {
            fontSize: "14px",
            fontFamily: 'Raleway, Arial',
            overflow: 'hidden',
            width: '460px',
            height: '170px'
        };
        const dataSourceStyle = {
            display: "block",
            width: "100px",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const comboStyle = {
            display: "block",
            width: "100%",
            height: "25px",
            zIndex: "0",
            vAlign: "middle"
        };
        return (
            <div style={divStyle}>
                <Container>
                    <Row>
                        <Col sm style={{marginLeft: '7px'}}>
                            <div id="wb_Checkbox1">
                                <input type="checkbox" ref={this.refContinuous} id="chkFill" name=""
                                       style={{display: "inline-block"}} onChange={(e) => {
                                    objeler.ModalPageValues.Continuous = e.target.checked;
                                    this.setState({visibleTemplate: objeler.ModalPageValues.Continuous})
                                    if (!objeler.ModalPageValues.Continuous) {
                                        this.refContinuousHeader.current.checked = false;
                                        this.refContinuousTemplate.current.checked = false;
                                        this.refShowEmptyPage.current.checked = false;
                                        objeler.ModalPageValues.ContinuousHeader = false
                                        objeler.ModalPageValues.ContinuousTemplate = false
                                        objeler.ModalPageValues.ShowEmptyPage = false
                                    }
                                }} defaultChecked={this.props.PageProps.Continuous}/>
                                <label htmlFor="Checkbox1"
                                       style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dynamic</label>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{marginLeft: '15px'}}>
                            <Container>
                                <Row>
                                    <Col>
                                        <Row style={{height: '10px'}}> </Row>
                                        <Row>
                                            <Col sm>
                                                <div id="wb_Checkbox1"
                                                     className={!this.state.visibleTemplate ? 'disabled' : null}>
                                                    <input type="checkbox" ref={this.refContinuousHeader}
                                                           id="chkContinuousHeader" name=""
                                                           style={{display: "inline-block"}}
                                                           onChange={(e) => objeler.ModalPageValues.ContinuousHeader = e.target.checked}
                                                           defaultChecked={this.props.PageProps.ContinuousHeader}/>
                                                    <label htmlFor="Checkbox1"
                                                           style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Apply
                                                        main datasource header objects all pages</label>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row style={{height: '10px'}}> </Row>
                                        <Row>
                                            <Col sm>
                                                <div id="wb_Checkbox1"
                                                     className={!this.state.visibleTemplate ? 'disabled' : null}>
                                                    <input type="checkbox" ref={this.refContinuousTemplate}
                                                           id="chkContinuousTemplate" name=""
                                                           style={{display: "inline-block"}}
                                                           onChange={(e) => objeler.ModalPageValues.ContinuousTemplate = e.target.checked}
                                                           defaultChecked={this.props.PageProps.ContinuousTemplate}/>
                                                    <label htmlFor="Checkbox1"
                                                           style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Apply
                                                        template to all pages </label>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row style={{height: '10px'}}> </Row>
                                        <Row>
                                            <Col sm>
                                                <div id="wb_Checkbox1"
                                                     className={!this.state.visibleTemplate ? 'disabled' : null}>
                                                    <input type="checkbox" ref={this.refShowEmptyPage}
                                                           id="chkShowEmptyPage" name=""
                                                           style={{display: "inline-block"}}
                                                           onChange={(e) => objeler.ModalPageValues.ShowEmptyPage = e.target.checked}
                                                           defaultChecked={this.props.PageProps.ShowEmptyPage}/>
                                                    <label htmlFor="Checkbox1"
                                                           style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Show
                                                        empty page </label>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row style={{height: '10px'}}> </Row>
                                        <Row>
                                            <Col sm>
                                                {/* FIX-MP-FOOTER-CFG: Footer zone height (pt). Sayfanın alt bu kadar piksel
                                                    her sayfada footer olarak tekrarlanır. Dynamic table taşmasında
                                                    totals/QR/signature bu çizginin üstünde son sayfada gösterilir. */}
                                                <div style={{display: 'flex', alignItems: 'center', marginLeft: '0px'}}>
                                                    <label htmlFor="txtFooterZoneHeight"
                                                           style={{fontSize: '14px', fontFamily: 'Raleway, Arial', marginRight: '8px'}}>
                                                        Footer Zone Height (pt):
                                                    </label>
                                                    <input type="number"
                                                           id="txtFooterZoneHeight"
                                                           min="0" max="400" step="5"
                                                           defaultValue={this.props.PageProps.FooterZoneHeight || 60}
                                                           style={{width: '70px', height: '24px', fontSize: '13px', padding: '2px 6px'}}
                                                           onChange={(e) => {
                                                               objeler.ModalPageValues.FooterZoneHeight = e.target.value;
                                                           }}/>
                                                    <span style={{fontSize: '11px', color: '#777', marginLeft: '10px'}}>
                                                        (Sayfa altı zone, her sayfada tekrar)
                                                    </span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default PageProperties;